import { AxiosInterceptor } from '../../Config/AxiosInterceptor'
import { AuthXInterceptor } from '../Config/AuthXInterceptor'

AxiosInterceptor()

export const orderDisputeBXService = {
  list: async (page = 1, limit = 25, sortOrder: 'ASC' | 'DESC' = 'ASC') => {
    return await AuthXInterceptor.get('order-disputes', {
      params: {
        page,
        limit,
        sortOrder,
      },
      headers: {
        accept: 'application/json',
      },
    })
  },

  show: async (disputeId: string) => {
    return await AuthXInterceptor.get(`order-disputes/${disputeId}`, {
      headers: {
        accept: 'application/json',
      },
    })
  },

  updateStatus: async (disputeId: string, status: string) => {
    return await AuthXInterceptor.put(
      `order-disputes/${disputeId}/status`,
      { status },
      {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    )
  },
}
